import {
  Anchor,
  Box,
  Button,
  Center,
  Divider,
  Group,
  HoverCard,
  SimpleGrid,
  ThemeIcon,
  UnstyledButton,
  rem,
  useMantineTheme,
  Text,
  Collapse,
} from "@mantine/core";
import {useDisclosure} from "@mantine/hooks";
import {IconChevronDown} from "@tabler/icons-react";
import {link} from "fs";
import React from "react";

import classes from "./MobileDropdown.module.scss";

type MobileDropdownProps = {
  label: string;
  dropdown: {
    title: string;
    viewAllLink?: string;
    subLinks: {
      link?: string | undefined;
      label: string;
      onClick?: Function | undefined;
      description: string;
      icon: any;
    }[];
    footer: {
      title: string;
      description: string;
      linkLabel: string;
      linkOnClick?: Function;
      openWaitlist?: any;
      link?: string;
    };
  };
};
export default function MobileDropdown({label, dropdown}: MobileDropdownProps) {
  const [dropdownOpened, {toggle: toggleDropdown}] = useDisclosure(false);
  const theme = useMantineTheme();

  const links = dropdown.subLinks.map((item) => (
    <UnstyledButton
      className={classes.subLink}
      key={item.label}
      onClick={item.onClick ? (e) => item.onClick!() : undefined}
      renderRoot={item.link ? (props) => <a href={item.link} {...props} /> : undefined}>
      <Group wrap="nowrap" align="flex-start">
        <ThemeIcon size={34} variant="default" radius="md" ml={rem(15)}>
          <item.icon style={{width: rem(22), height: rem(22)}} color={theme.colors.blue[6]} />
        </ThemeIcon>
        <div>
          <Text size="sm" fw={500}>
            {item.label}
          </Text>
          <Text size="xs" c="dimmed">
            {item.description}
          </Text>
        </div>
      </Group>
    </UnstyledButton>
  ));

  return (
    <>
      <UnstyledButton className={classes.link} onClick={toggleDropdown}>
        <Center inline>
          <Box component="span" mr={5}>
            {label}
          </Box>
          <IconChevronDown style={{width: rem(16), height: rem(16)}} color={theme.colors.blue[6]} />
        </Center>
      </UnstyledButton>
      <Collapse in={dropdownOpened}>{links}</Collapse>
    </>
  );
}
